import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { RECEIVED_STATUS } from 'domains/seller-inbound/constants'


const propTypes = {
  received_status: PropTypes.string
}

/**
 * To give nice look on Seller Inbound `received_status`.
 * It maps `received status` to certain style and pass to `StatusBadge`.
 * @param {string} received_status Seller Inbound received status. available values
 * - `pending`
 * - `received`
 */
const SellerInboundReceivedStatusBadge = ({ received_status }) => {

  const colorMap = {
    [RECEIVED_STATUS.RECEIVED]  : 'success',
    [RECEIVED_STATUS.PENDING]   : 'warning',
    [RECEIVED_STATUS.CANCELLED] : 'danger'
  }

  const color = colorMap[received_status] || 'default'

  return <StatusBadge color={ color } label={ received_status } />
}

SellerInboundReceivedStatusBadge.propTypes = propTypes

export default SellerInboundReceivedStatusBadge